
const digest = 'b1db43002fa533e1d3012aa91990d5409606e3cd3f6d8361dec5bb44192b3fab';
const classes = {"wrapper":"_wrapper_1pu54_1","header":"_header_1pu54_9","date":"_date_1pu54_20","typeOfConsultation":"_typeOfConsultation_1pu54_24","doctor":"_doctor_1pu54_28","list":"_list_1pu54_32","item":"_item_1pu54_60","meetingType":"_meetingType_1pu54_77","content":"_content_1pu54_84","name":"_name_1pu54_92","workplace":"_workplace_1pu54_96","title":"_title_1pu54_100","note":"_note_1pu54_106"};
const css = `._wrapper_1pu54_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  background: #ffffff;
  font-family: Rubik, "sans-serif";
}
._wrapper_1pu54_1 ._header_1pu54_9 {
  display: flex;
  flex-direction: row;
  gap: 28px;
  padding: 6px 19px;
  font-size: 14px;
  font-weight: 500;
  background: #fbfbfd !important;
  border-right: 1px solid #eaedf3;
  border-left: 1px solid #eaedf3;
}
._wrapper_1pu54_1 ._header_1pu54_9 ._date_1pu54_20 {
  min-width: 150px;
  max-width: 150px;
}
._wrapper_1pu54_1 ._header_1pu54_9 ._typeOfConsultation_1pu54_24 {
  min-width: 120px;
  max-width: 120px;
}
._wrapper_1pu54_1 ._header_1pu54_9 ._doctor_1pu54_28 {
  min-width: 200px;
  max-width: 200px;
}
._wrapper_1pu54_1 ._list_1pu54_32 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_1pu54_1 ._list_1pu54_32::-webkit-scrollbar {
  display: block;
}
._wrapper_1pu54_1 ._list_1pu54_32::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_1pu54_1 ._list_1pu54_32::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_1pu54_1 ._list_1pu54_32::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1pu54_1 ._list_1pu54_32::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60 {
  display: flex;
  flex-direction: row;
  padding: 24px 19px;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60 ._date_1pu54_20 {
  font-size: 14px;
  color: #000000;
  min-width: 150px;
  max-width: 150px;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60 ._meetingType_1pu54_77 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  min-width: 120px;
  max-width: 120px;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60 ._content_1pu54_84 {
  flex: 1;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60 ._doctor_1pu54_28 {
  color: #000000;
  min-width: 200px;
  max-width: 200px;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60 ._doctor_1pu54_28 ._name_1pu54_92 {
  font-size: 14px;
  font-weight: 500;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60 ._doctor_1pu54_28 ._workplace_1pu54_96 {
  font-size: 12px;
  font-weight: 400;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60 ._title_1pu54_100 {
  color: #000000;
  font-weight: 500;
  flex-grow: 1;
  font-size: 14px;
}
._wrapper_1pu54_1 ._list_1pu54_32 ._item_1pu54_60 ._note_1pu54_106 {
  font-size: 12px;
  font-weight: 400;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  